import { render, staticRenderFns } from "./projectAreaDetail.vue?vue&type=template&id=397a82b2&scoped=true&"
import script from "./projectAreaDetail.vue?vue&type=script&lang=js&"
export * from "./projectAreaDetail.vue?vue&type=script&lang=js&"
import style0 from "./projectAreaDetail.vue?vue&type=style&index=0&id=397a82b2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397a82b2",
  null
  
)

export default component.exports